export const TestGroupCoreEnrollmentNextArray = ["Health Plan"];
